import { createPublicClient, http } from "viem";

import { currentChain } from "./chains";

export const publicClient = (() => {
  // TODO @tom2drum public clients for multichain (currently used only in degradation views)
  const rpcUrl = currentChain?.rpcUrls.default.http.find(Boolean);
  if (!rpcUrl) {
    return;
  }

  try {
    return createPublicClient({
      chain: currentChain,
      transport: http(rpcUrl),
      batch: {
        multicall: true,
      },
    });
  } catch (error) {}
})();
